// src/serviceWorkerRegistration.js
export function registerServiceWorker() {
  // Permite registro em dev e production para testar PWA localmente
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registrado com sucesso:', registration);

        // Atualiza periodicamente
        setInterval(() => registration.update(), 1000 * 60 * 60); // 1h

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('Nova versão disponível! Atualizando automaticamente...');
              newWorker.postMessage({ type: 'SKIP_WAITING' });

              // Fallback: exibe snackbar caso o skipWaiting não recarregue a página
              setTimeout(() => {
                if (!refreshing) {
                  const snackbar = document.getElementById('snackbar');
                  if (snackbar) snackbar.classList.add('show');

                  const reloadButton = document.getElementById('reload');
                  if (reloadButton) {
                    reloadButton.onclick = () => {
                      newWorker.postMessage({ type: 'SKIP_WAITING' });
                    };
                  }
                }
              }, 3000); // aguarda 3s para o reload automático acontecer antes de mostrar o botão
            }
          });
        });

        // Recarrega quando o novo SW assumir
        let refreshing;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          window.location.reload();
          refreshing = true;
        });
      })
      .catch((err) => console.error('Falha ao registrar Service Worker:', err));
  });
}
